export default function Nosotros() {
  return (
    <div className="pt-32 pb-20 bg-white min-h-screen">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        <div
          className="rounded-[28px] overflow-hidden shadow-soft"
          style={{ background: 'linear-gradient(150deg, #6D1B54 0%, #2B0822 100%)' }}
        >
          <div className="aspect-[4/5] flex items-center justify-center p-10">
            <img src="/logo.png" alt="Soda Celes" className="max-h-full drop-shadow-2xl" />
          </div>
        </div>
        <div>
          <span className="text-accent font-bold text-xs tracking-[3px] uppercase mb-3 block">Nuestra Historia</span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-wine-darker mb-5 leading-snug">
            Comida hecha con el mismo cariño de siempre
          </h2>
          <p className="text-ink/60 mb-4">
            Soda Celes nació de las ganas de compartir la sazón de casa con todo el vecindario.
            Cada plato se prepara al momento, con ingredientes frescos y esa sazón que solo se
            consigue con años de práctica en la cocina.
          </p>
          <p className="text-ink/60 mb-8">
            Hoy seguimos siendo ese lugar de confianza para el desayuno rápido, el almuerzo del
            día, o ese antojito de media tarde.
          </p>
          <div className="flex gap-10">
            <div>
              <b className="font-display text-3xl text-wine block">100%</b>
              <span className="text-xs text-ink/40 tracking-wide">INGREDIENTES FRESCOS</span>
            </div>
            <div>
              <b className="font-display text-3xl text-wine block">★★★★★</b>
              <span className="text-xs text-ink/40 tracking-wide">SABOR DE CASA</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
